import { liveQuoteTradeApiConnector } from 'apiConnector/secondary-market/live/trade';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { liveTradeCancellationActions } from 'state/secondaryMarket/live/cancellation/cancellations.actions';
import { liveCancellationThunks } from 'state/secondaryMarket/live/cancellation/cancellations.thunks';
import type { EpicWithThunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';

export function cancelLiveTradeEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient, frontLogger }) =>
    actions$.pipe(
      ofType('SECONDARY_MARKET_LIVE_CANCELLATION_REQUESTED'),
      mergeMap(({ orderId }) => {
        return liveQuoteTradeApiConnector(httpClient)
          .cancelTrade(orderId)
          .pipe(
            map(response => liveTradeCancellationActions.secondaryMarketCancelReceived(orderId, response)),
            catchError((error: HttpError) => {
              frontLogger.error('An error occurred inside orderCancellationRequestedEpic {@FrontError}', error);
              return of(liveCancellationThunks.orderCancellationErrorsThunk(orderId, error));
            }),
          );
      }),
    );
}
